import React from 'react';
import { Link } from 'react-router-dom';
import DhobaraSiteNav from '../DhobaraSiteNav/DhobaraSiteNav';
import logoImg from '../../assets/dhobara-logo.png';
import css from './DhobaraPageLayout.module.css';

const IconInstagram = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
    <rect x="2" y="2" width="20" height="20" rx="5" fill="none" />
    <circle cx="12" cy="12" r="4" fill="none" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const IconTikTok = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
    <path d="M20 8a5 5 0 0 0-8-4V16a4 4 0 1 1-4-4" />
  </svg>
);

const FOOTER_LINKS_SELLING = [
  { label: 'Sell with us', to: '/dashboard' },
  { label: 'How it Works', to: '/how-it-works' },
  { label: 'Seller Terms & Conditions', to: '/seller-terms' },
  { label: 'Pricing & payouts', to: '/seller-terms' },
  { label: 'Designers We Accept', to: '/designers' },
];

const FOOTER_LINKS_BUYING = [
  { label: 'How it works', to: '/how-it-works' },
  { label: 'Browse designers', to: '/designers' },
  { label: 'Buyer Protection', to: '/returns' },
  { label: 'Shipping', to: '/shipping' },
  { label: 'Return Policy', to: '/returns' },
];

const FOOTER_LINKS_COMPANY = [
  { label: 'About Us', to: '/why-dhobara' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact us', to: '/contact' },
];

/**
 * DhobaraPageLayout — shared nav + footer wrapper for all Dhobara content pages.
 */
const DhobaraPageLayout = ({ children }) => {
  return (
    <div className={css.root}>
      {/* NAV */}
      <DhobaraSiteNav />

      {/* PAGE CONTENT */}
      <main className={css.main}>
        {children}
      </main>

      {/* FOOTER */}
      <footer className={css.footer}>
        <div className={css.footerMain}>
          <div>
            <span className={css.footerHeading}>Selling</span>
            <ul className={css.footerLinks}>
              {FOOTER_LINKS_SELLING.map(l => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <span className={css.footerHeading}>Buying</span>
            <ul className={css.footerLinks}>
              {FOOTER_LINKS_BUYING.map(l => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <span className={css.footerHeading}>Company</span>
            <ul className={css.footerLinks}>
              {FOOTER_LINKS_COMPANY.map(l => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className={css.footerDivider} />
        <div className={css.footerBottom}>
          <div className={css.footerBottomLeft}>
            <img src={logoImg} alt="Dhobara" className={css.footerLogo} />
            <p className={css.footerDisclaimer}>
              Dhobara is an independent resale marketplace. All brand names and logos are trademarks of their respective owners. Dhobara is not affiliated with or endorsed by any of the brands listed.
            </p>
            <span className={css.footerCopy}>© {new Date().getFullYear()} Dhobara</span>
          </div>
          <div className={css.footerBottomRight}>
            <div className={css.footerSocials}>
              <a href="https://www.instagram.com/dhobara_store/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={css.footerInstagram}>
                <IconInstagram />
              </a>
              <a href="https://www.tiktok.com/@dhobara_store?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className={css.footerInstagram}>
                <IconTikTok />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DhobaraPageLayout;
